<template>
  <transition name="modal-fade">
    <div v-if="isOpen" class="shorts-player-modal" @click.self="closePlayer">
      <div class="modal-container">
        <!-- Botón de cerrar flotante -->
        <button @click="closePlayer" class="close-btn" title="Cerrar (Esc)">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <line x1="18" y1="6" x2="6" y2="18"/>
            <line x1="6" y1="6" x2="18" y2="18"/>
          </svg>
        </button>

        <!-- Reproductor de Shorts (YouTube Shorts o TikTok) -->
        <div class="player-wrapper">
          <iframe
            v-if="videoId"
            :src="embedUrl"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen"
            allowfullscreen
            playsinline
            class="shorts-iframe"
            scrolling="no"
          ></iframe>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ShortsVideoPlayer',
  data() {
    return {
      isOpen: false,
      videoId: null,
      videoTitle: '',
      videoType: 'youtube'
    };
  },
  computed: {
    embedUrl() {
      if (!this.videoId) return '';

      if (this.videoType === 'tiktok') {
        // TikTok player v1 con autoplay
        return `https://www.tiktok.com/player/v1/${this.videoId}?autoplay=1&controls=1&music_info=1&description=1`;
      } else {
        // YouTube Shorts embed
        // Usar el formato de shorts para mejor experiencia vertical
        return `https://www.youtube.com/embed/${this.videoId}?autoplay=1&rel=0&modestbranding=1&fs=1&playsinline=1`;
      }
    }
  },
  methods: {
    openPlayer(videoId, title, videoType = 'youtube') {
      this.videoId = videoId;
      this.videoTitle = title;
      this.videoType = videoType;
      this.isOpen = true;
      document.body.style.overflow = 'hidden'; // Prevenir scroll del body
    },
    closePlayer() {
      this.isOpen = false;
      this.videoId = null;
      this.videoTitle = '';
      this.videoType = 'youtube';
      document.body.style.overflow = ''; // Restaurar scroll
    },
    handleEscKey(event) {
      if (event.key === 'Escape' && this.isOpen) {
        this.closePlayer();
      }
    }
  },
  mounted() {
    // Escuchar tecla ESC para cerrar
    window.addEventListener('keydown', this.handleEscKey);
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.handleEscKey);
    document.body.style.overflow = '';
  }
};
</script>

<style scoped>
/* Modal overlay */
.shorts-player-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.95);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  overflow: hidden;
}

.modal-container {
  position: relative;
  width: 100%;
  max-width: 450px; /* Ancho máximo para formato vertical */
  display: flex;
  flex-direction: column;
}

/* Botón de cerrar flotante */
.close-btn {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  z-index: 10;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
}

.close-btn:hover {
  background: rgba(0, 0, 0, 0.8);
  transform: scale(1.1);
  border-color: rgba(255, 255, 255, 0.4);
}

/* Player wrapper - formato vertical 9:16 */
.player-wrapper {
  position: relative;
  width: 100%;
  padding-bottom: 177.78%; /* 9:16 aspect ratio para formato vertical */
  background: #000;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.8);
}

.shorts-iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

/* Animations */
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.3s ease;
}

.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
}

.modal-fade-enter-active .modal-container,
.modal-fade-leave-active .modal-container {
  transition: transform 0.3s ease;
}

.modal-fade-enter-from .modal-container,
.modal-fade-leave-to .modal-container {
  transform: scale(0.9);
}

/* Responsive */
@media (max-width: 768px) {
  .shorts-player-modal {
    padding: 8px;
  }

  .modal-container {
    max-height: calc(100vh - 16px);
    max-width: 100%;
  }

  .close-btn {
    top: 8px;
    right: 8px;
    width: 40px;
    height: 40px;
  }

  .player-wrapper {
    border-radius: 8px;
  }
}

@media (max-width: 480px) {
  .shorts-player-modal {
    padding: 4px;
  }

  .modal-container {
    max-width: 100%;
    max-height: calc(100vh - 8px);
  }

  .close-btn {
    top: 8px;
    right: 8px;
    width: 36px;
    height: 36px;
  }

  .close-btn svg {
    width: 20px;
    height: 20px;
  }

  .player-wrapper {
    border-radius: 0;
  }
}
</style>
